import { render, staticRenderFns } from "./proReviewFooter.vue?vue&type=template&id=2d4fd0b3&scoped=true&"
import script from "./proReviewFooter.vue?vue&type=script&lang=js&"
export * from "./proReviewFooter.vue?vue&type=script&lang=js&"
import style0 from "./proReviewFooter.vue?vue&type=style&index=0&id=2d4fd0b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4fd0b3",
  null
  
)

export default component.exports